import * as t from "io-ts";
import { BigIntFromString } from "io-ts-types";

/**
 * @deprecated use `assetKeys` instead
 */
export const assetKeysLegacy = ["base", "firstBridge", "secondBridge"] as const;

/**
 * @deprecated use `AssetKey` instead
 */
export type AssetKeyLegacy = (typeof assetKeysLegacy)[number];

/**
 * Represents a value that may not be applicable or may be loading.
 */
export type PotentialValue<T> =
  | { _tag: "none" }
  | { _tag: "loading" }
  | { _tag: "loaded"; value: T };

export type CollateralType = "none" | "dual" | "protected" | "borrowable";

/**
 * @deprecated use `LiquidationPrice` instead
 */
export const LiquidationPriceLegacy = t.union([
  t.type({ _tag: t.literal("notApplicable") }),
  t.type({ _tag: t.literal("applicable"), value: BigIntFromString }),
]);
export type LiquidationPriceLegacy = t.TypeOf<typeof LiquidationPriceLegacy>;

export type SubsetOf<T, U extends T> = U;

export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

export type TrueKeys<T> = {
  [K in keyof T]: T[K] extends true ? K : never;
}[keyof T];
